"use client";

/**
 * PostDetailAnalytics 컴포넌트
 * @description 글이 열렸음을 한 번 남기고, 읽기 진행 띠가 끝에 닿으면 완독을 한 번 남긴다.
 *   그리는 것은 읽기 진행 띠(`ReadingProgress`)뿐이다.
 */
import { memo, useCallback, useEffect, useRef } from "react";

import { POST_ARTICLE_ID } from "./PostDetailBody";
import type { PostDetailAnalyticsProps } from "./PostDetail.types";

import { trackBlogReadCompleted, trackBlogViewed } from "../../analytics";
import { ReadingProgress } from "@/shared/ui";

const PostDetailAnalytics = memo<PostDetailAnalyticsProps>(
  ({ post, readingMinutes }) => {
    const hasViewed = useRef(false);
    const hasCompleted = useRef(false);

    useEffect(() => {
      if (hasViewed.current) return;
      hasViewed.current = true;
      trackBlogViewed(post, readingMinutes);
    }, [post, readingMinutes]);

    const onComplete = useCallback(() => {
      if (hasCompleted.current) return;
      hasCompleted.current = true;
      trackBlogReadCompleted(post);
    }, [post]);

    return (
      <ReadingProgress targetId={POST_ARTICLE_ID} onComplete={onComplete} />
    );
  },
);

PostDetailAnalytics.displayName = "PostDetailAnalytics";

export default PostDetailAnalytics;
